<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <template slot="footer">
      <a-button key="close" @click="handleCancel">
        {{ $t('关闭') }}
      </a-button>
    </template>
    <div class="form-contain">
    <a-spin :spinning="confirmLoading">
        <detail-list size="small">
          <detail-list-item :term="$t('命令类型')">{{commandName}}</detail-list-item>
          <detail-list-item :term="$t('命令状态')">{{reportStatusObj[model.status]?$t(reportStatusObj[model.status]):''}}</detail-list-item>
          <detail-list-item :term="$t('表编号')">{{model.meterId}}</detail-list-item>
          <detail-list-item :term="$t('发送时间')">{{model.sendTime}}</detail-list-item>
          <detail-list-item :term="$t('回应时间')">{{model.receiveTime}}</detail-list-item>
          <detail-list-item :term="$t('创建时间')">{{model.createTime}}</detail-list-item>
          <detail-list-item :term="$t('更新时间')">{{model.updateTime}}</detail-list-item>
        </detail-list>
      <a-form :colon="colon" layout="vertical">
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-item  :label="$t('命令参数')">
              <a-textarea :readOnly="disableSubmit" :placeholder="$t('请输入命令参数')" v-model="model.cmdParam" />
            </a-form-item>
          </a-col>
          <!--
          <a-col :span="24">
            <a-form-item  label="命令内容">
              <a-textarea :readOnly="disableSubmit" placeholder="请输入命令内容" v-model="model.cmdContent" />
            </a-form-item>
          </a-col>
          -->
          <a-col :span="24">
            <a-form-item  :label="$t('命令回应')">
              <a-textarea :readOnly="disableSubmit" placeholder="" v-model="model.receiveContent" />
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="model.remark!=''&&model.remark!=null">
            <a-form-item  :label="$t('命令回应内容')">
              <a-textarea :readOnly="disableSubmit" placeholder="" v-model="model.remark" />
            </a-form-item>
          </a-col>
          
          <!-- <a-col :span="24">
            <a-form-item  label="备注">
              <a-textarea :readOnly="disableSubmit" placeholder="请输入备注" v-decorator="['remark', {}]" />
            </a-form-item>
          </a-col> -->
        </a-row>
      </a-form>
    </a-spin>
    </div>
  </j-modal>
</template>

<script>
  import { httpAction,getAction } from '@/api/manage'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {dataFlagObj,reportStatusObj} from '@/utils/constants/protocolConstant'
  import {meterTypeObj} from '@/utils/constants/commonConstant'

  const cmdList= {'8110_01':'读取采集器NB网络参数','8105_01':'读取上传间隔','8104_01':'读取自动上传时间点','8110_04': '设置采集器NB网络参数','a02a_04':'设置阀门角度','a029_04':'阀门角度校正','8105_04':'设置上传间隔','8104_04':'设置自动上传时间点'}

  export default {
    name: "PartValveServiceQueueModal",
    components: {
      DetailList,
      DetailListItem
    },
    data () {
      return {
        meterTypeObj,
        cmdList,
        disableSubmit: false,
        visible: false,
        colon: false,
        model: {},
        reportStatusObj: reportStatusObj,
        confirmLoading: false,
        validatorRules:{
        },
        url: {
          add: "/model/partCommand/add",
          edit: "/model/partCommand/edit",
          queryCMDDetailById:"/jeecg-charge/part/partValveCommand/queryDetailCMDById"
        },
        commandNameList: dataFlagObj,
      }
    },
    created () {
    },
    computed: {
        title() {
            return this.$t('操作')
        },
        commandName() {
            if(this.model.cmd) {
                const name = this.cmdList[this.model.cmd];
                return name ? this.$t(name) : this.$t('未知');
            }else{
              return this.$t("未知");
            }
        }
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.queryCMDDetailById(record)
        this.visible = true;
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      },
      queryCMDDetailById(record) {
        this.model = {}
        console.log(record);
        let params = {}
        params.id = record.id;
        getAction(this.url.queryCMDDetailById, params).then((res) => {
          if(res.success){
            this.model = Object.assign({}, res.result);
          }
        }) 
      },
    }
  }
</script>

<style lang="less" scoped>
.form-contain{
  height: 60vh;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>